export default {"src":"/_next/static/media/yesYellow.7f4bd68d.svg","height":25,"width":24};